export default __webpack_public_path__ + "static/media/esfp@3x.67a3abe9.png";